import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.error.cause.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.push.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { browserTracingIntegration, startBrowserTracingPageLoadSpan, startBrowserTracingNavigationSpan, WINDOW } from '@sentry/browser';
import { SEMANTIC_ATTRIBUTE_SENTRY_OP, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, getCurrentScope, getActiveSpan, getRootSpan, spanToJSON } from '@sentry/core';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as React from 'react';

// We need to disable eslint no-explicit-any because any is required for the
// react-router typings.

/**
 * A browser tracing integration that uses React Router v4 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */
function reactRouterV4BrowserTracingIntegration(options) {
  var integration = browserTracingIntegration(_objectSpread(_objectSpread({}, options), {}, {
    instrumentPageLoad: false,
    instrumentNavigation: false
  }));
  var history = options.history,
    routes = options.routes,
    matchPath = options.matchPath,
    _options$instrumentPa = options.instrumentPageLoad,
    instrumentPageLoad = _options$instrumentPa === void 0 ? true : _options$instrumentPa,
    _options$instrumentNa = options.instrumentNavigation,
    instrumentNavigation = _options$instrumentNa === void 0 ? true : _options$instrumentNa;
  return _objectSpread(_objectSpread({}, integration), {}, {
    afterAllSetup: function afterAllSetup(client) {
      integration.afterAllSetup(client);
      instrumentReactRouter(client, instrumentPageLoad, instrumentNavigation, history, 'reactrouter_v4', routes, matchPath);
    }
  });
}

/**
 * A browser tracing integration that uses React Router v5 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */
function reactRouterV5BrowserTracingIntegration(options) {
  var integration = browserTracingIntegration(_objectSpread(_objectSpread({}, options), {}, {
    instrumentPageLoad: false,
    instrumentNavigation: false
  }));
  var history = options.history,
    routes = options.routes,
    matchPath = options.matchPath,
    _options$instrumentPa2 = options.instrumentPageLoad,
    instrumentPageLoad = _options$instrumentPa2 === void 0 ? true : _options$instrumentPa2,
    _options$instrumentNa2 = options.instrumentNavigation,
    instrumentNavigation = _options$instrumentNa2 === void 0 ? true : _options$instrumentNa2;
  return _objectSpread(_objectSpread({}, integration), {}, {
    afterAllSetup: function afterAllSetup(client) {
      integration.afterAllSetup(client);
      instrumentReactRouter(client, instrumentPageLoad, instrumentNavigation, history, 'reactrouter_v5', routes, matchPath);
    }
  });
}
function instrumentReactRouter(client, instrumentPageLoad, instrumentNavigation, history, instrumentationName) {
  var allRoutes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var matchPath = arguments.length > 6 ? arguments[6] : undefined;
  function getInitPathName() {
    if (history && history.location) {
      return history.location.pathname;
    }
    if (WINDOW && WINDOW.location) {
      return WINDOW.location.pathname;
    }
    return undefined;
  }

  /**
   * Normalizes a transaction name. Returns the new name as well as the
   * source of the transaction.
   *
   * @param pathname The initial pathname we normalize
   */
  function normalizeTransactionName(pathname) {
    if (allRoutes.length === 0 || !matchPath) {
      return [pathname, 'url'];
    }
    var branches = matchRoutes(allRoutes, pathname, matchPath);
    var _iterator = _createForOfIteratorHelper(branches),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var branch = _step.value;
        if (branch.match.isExact) {
          return [branch.match.path, 'route'];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [pathname, 'url'];
  }
  if (instrumentPageLoad) {
    var initPathName = getInitPathName();
    if (initPathName) {
      var _attributes;
      var _normalizeTransaction = normalizeTransactionName(initPathName),
        _normalizeTransaction2 = _slicedToArray(_normalizeTransaction, 2),
        name = _normalizeTransaction2[0],
        source = _normalizeTransaction2[1];
      startBrowserTracingPageLoadSpan(client, {
        name: name,
        attributes: (_attributes = {}, _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_OP, 'pageload'), _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.pageload.react.".concat(instrumentationName)), _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, source), _attributes)
      });
    }
  }
  if (instrumentNavigation && history.listen) {
    history.listen(function (location, action) {
      if (action && (action === 'PUSH' || action === 'POP')) {
        var _attributes2;
        var _normalizeTransaction3 = normalizeTransactionName(location.pathname),
          _normalizeTransaction4 = _slicedToArray(_normalizeTransaction3, 2),
          _name = _normalizeTransaction4[0],
          _source = _normalizeTransaction4[1];
        startBrowserTracingNavigationSpan(client, {
          name: _name,
          attributes: (_attributes2 = {}, _defineProperty(_attributes2, SEMANTIC_ATTRIBUTE_SENTRY_OP, 'navigation'), _defineProperty(_attributes2, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.navigation.react.".concat(instrumentationName)), _defineProperty(_attributes2, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, _source), _attributes2)
        });
      }
    });
  }
}

/**
 * Matches a set of routes to a pathname
 * Based on implementation from
 */
function matchRoutes(routes, pathname, matchPath) {
  var branch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  routes.some(function (route) {
    var match = route.path ? matchPath(pathname, route) : branch.length ?
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    branch[branch.length - 1].match // use parent match
    : computeRootMatch(pathname); // use default "root" match

    if (match) {
      branch.push({
        route: route,
        match: match
      });
      if (route.routes) {
        matchRoutes(route.routes, pathname, matchPath, branch);
      }
    }
    return !!match;
  });
  return branch;
}
function computeRootMatch(pathname) {
  return {
    path: '/',
    url: '/',
    params: {},
    isExact: pathname === '/'
  };
}

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
function withSentryRouting(Route) {
  var componentDisplayName = Route.displayName || Route.name;
  var WrappedRoute = function WrappedRoute(props) {
    if (props && props.computedMatch && props.computedMatch.isExact) {
      var route = props.computedMatch.path;
      var activeRootSpan = getActiveRootSpan();
      getCurrentScope().setTransactionName(route);
      if (activeRootSpan) {
        activeRootSpan.updateName(route);
        activeRootSpan.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, 'route');
      }
    }

    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params:
    // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
    return /*#__PURE__*/React.createElement(Route, _objectSpread({}, props));
  };
  WrappedRoute.displayName = "sentryRoute(".concat(componentDisplayName, ")");
  hoistNonReactStatics(WrappedRoute, Route);
  // @ts-expect-error Setting more specific React Component typing for `R` generic above
  // will break advanced type inference done by react router params:
  // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
  return WrappedRoute;
}
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */

function getActiveRootSpan() {
  var span = getActiveSpan();
  var rootSpan = span && getRootSpan(span);
  if (!rootSpan) {
    return undefined;
  }
  var op = spanToJSON(rootSpan).op;

  // Only use this root span if it is a pageload or navigation span
  return op === 'navigation' || op === 'pageload' ? rootSpan : undefined;
}
export { reactRouterV4BrowserTracingIntegration, reactRouterV5BrowserTracingIntegration, withSentryRouting };